import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';

// const URL = 'https://aifolio-api.herokuapp.com/api/user/get/all';

const URL = 'https://aifolio-api.herokuapp.com/api/user/get/all';

const AuthContext = React.createContext({
  isLoggedIn: false,
  userDetails: '',
  pathname: '',
  userDataHandler: '',
  pathnameHandler: (event) => {},
  isAdminHandler: (event) => {},
  logoutHandler: (event) => {},
  newReqHandler: (event) => {},
});

export const AuthContextProvider = ({ children }) => {
  const [newReq, setNewReq] = useState(false);
  const [isAdmin, setIsAdmin] = useState('');
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [pathname, setPathname] = useState(window.location.pathname);

  const userDataHandler = (data) => {
    setUserDetails(data);
  };

  const fetchDetails = () => {
    setLoading(true);
    fetch(URL)
      .then((res) => res.json())
      .then((data) => {
        if (+data?.length > 0) {
          setUserDetails(data[0]);
        }
        setLoading(false);
      });
  };

  const pathnameHandler = (path) => {
    setPathname(path);
  };

  const newReqHandler = () => {
    setNewReq(!newReq);
  };

  useEffect(() => {
    fetchDetails();
  }, [newReq]);

  useEffect(() => {}, [pathname, userDetails]);

  const isAdminHandler = (condition) => {
    setIsAdmin(condition);
  };

  useEffect(() => {}, [isAdmin]);

  useEffect(() => {
    const getToken = localStorage.getItem('isAdmin');

    if (JSON.parse(getToken)) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const logoutHandler = (arg) => {
    setIsLoggedIn(arg);
  };
  return (
    <AuthContext.Provider
      value={{
        pathname: pathname,
        isAdmin: isAdmin,
        loading: loading,
        isLoggedIn: isLoggedIn,
        userDetails: userDetails,
        userDataHandler: userDataHandler,
        pathnameHandler: pathnameHandler,
        logoutHandler: logoutHandler,
        isAdminHandler: isAdminHandler,
        newReqHandler: newReqHandler,
        newReqVal: newReq,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
